import { Service } from '../config'

class PreparationService extends Service {
  path = 'preparacao'

  async get(
    perPage: number,
    page: number,
    sortField: string = '',
    sortAscending: boolean = true,
    params?: any
  ) {
    const payloadSubmitted = {
      ...params,
      'Pagination.PageSize': perPage,
      'Pagination.Page': page,
      'Pagination.SortField': sortField,
      'Pagination.SortAscending': sortAscending
    }

    const httpResponse = await this.httpClient.get(`/${this.path}`, {
      params: payloadSubmitted
    })
    return httpResponse
  }

  async download(params?: any) {
    const searchParams = new URLSearchParams()

    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          searchParams.append(key, params[key])
        }
      })
    }

    const httpResponse = await this.httpClient.get(
      `/${this.path}/excel?${searchParams}`
    )
    return httpResponse
  }

  async indicators() {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/obterindicadores`
    )
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(`/${this.path}`, params)
    return httpResponse
  }

  async getServices(params: any) {
    const httpResponse = await this.httpClient.get(`/${this.path}/servicos`, {
      params
    })
    return httpResponse
  }

  async getProducts(params: any) {
    const httpResponse = await this.httpClient.get(`/${this.path}/produtos`, {
      params
    })
    return httpResponse
  }

  async getProvider(id: string) {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/prestador?preparacaoId=${id}`
    )
    return httpResponse
  }

  async putServices(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/atualizarservicos`,
      params
    )
    return httpResponse
  }

  async postServices(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/inserirservico`,
      params
    )
    return httpResponse
  }

  async putService(params: any) {
    const httpResponse = await this.httpClient.put(
      `${this.path}/atualizarservicosindividual`,
      params
    )
  }

  async putProducts(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/atualizarprodutos`,
      params
    )
    return httpResponse
  }

  async postProducts(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/inserirproduto`,
      params
    )
    return httpResponse
  }

  async putProvider(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/vincularprestador`,
      params
    )
    return httpResponse
  }

  async putBreakdowns(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/atualizaravarias`,
      params
    )
    return httpResponse
  }

  async getBreakdown(params?: any) {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/obteravarias`,
      { params }
    )
    return httpResponse
  }

  async finalize(params?: any) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/finalizar`,
      params
    )
    return httpResponse
  }

  async getHistoric(id: string) {
    const httpResponse = await this.httpClient.get(
      `/${this.path}/historico?preparacaoId=${id}`
    )
    return httpResponse
  }

  async preparationComplete(params: any) {
    const httpResponse = await this.httpClient.post(
      `/${this.path}/concluir`,
      params
    )
    return httpResponse
  }

  async preparationCancel(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/cancelar`,
      params
    )
    return httpResponse
  }

  async putPreparation(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/editarpreparacao`,
      params
    )
    return httpResponse
  }

  async putRealValue(params: any) {
    const httpResponse = await this.httpClient.put(
      `/${this.path}/atualizarValorRealizado `,
      params
    )
    return httpResponse
  }

  async deleteService(params: any) {
    const httpResponse = await this.httpClient.delete(
      `${this.path}/excluirservico`,
      { params }
    )
    return httpResponse
  }

  async deleteProduct(params: any) {
    const httpResponse = await this.httpClient.delete(
      `${this.path}/excluirproduto`,
      { params }
    )
    return httpResponse
  }

  async generateSummary(params: any) {
    const httpResponse = await this.httpClient.post(
      `${this.path}/impressao`,
      params
    )
    return httpResponse
  }
}

export const preparationService = new PreparationService()
